module.exports = __webpack_public_path__ + "img/keyboard_Arrow_Right.7cf276ce.png";